var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2659_10699)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2659_10699)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9814 28.4446V18.2848C28.9814 17.5195 28.3591 16.8972 27.5938 16.8972H23.8492V12.2372C23.8492 12.182 23.837 11.4885 23.234 11.0844C22.6309 10.6808 21.9849 10.9336 21.9336 10.9541L12.5192 14.8308C11.9977 15.0458 11.6602 15.5487 11.6602 16.1139V28.4446H11.0187C10.6646 28.4446 10.3772 28.732 10.3772 29.0861C10.3772 29.4402 10.6646 29.7276 11.0187 29.7276H12.3018H23.2077H28.3398H28.9814C29.3355 29.7276 29.6229 29.4402 29.6229 29.0861C29.6229 28.732 29.3355 28.4446 28.9814 28.4446ZM12.9433 16.1139C12.9433 16.0716 12.969 16.0337 13.0081 16.0177L22.4224 12.1416C22.4577 12.1275 22.4898 12.1307 22.5199 12.1512C22.5507 12.1711 22.5661 12.2 22.5661 12.2372V17.5387V28.4446H12.9433V16.1139ZM23.8492 28.4446V18.1802H27.5938C27.6515 18.1802 27.6983 18.2271 27.6983 18.2848V28.4446H23.8492Z",
    fill: "url(#paint0_linear_2659_10699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 25.2371H16.1508C15.7967 25.2371 15.5093 25.5245 15.5093 25.8786C15.5093 26.2327 15.7967 26.5201 16.1508 26.5201H19.3584C19.7125 26.5201 19.9999 26.2327 19.9999 25.8786C19.9999 25.5245 19.7125 25.2371 19.3584 25.2371Z",
    fill: "url(#paint1_linear_2659_10699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 22.6709H16.1508C15.7967 22.6709 15.5093 22.9583 15.5093 23.3124C15.5093 23.6665 15.7967 23.9539 16.1508 23.9539H19.3584C19.7125 23.9539 19.9999 23.6665 19.9999 23.3124C19.9999 22.9583 19.7125 22.6709 19.3584 22.6709Z",
    fill: "url(#paint2_linear_2659_10699)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2659_10699",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2659_10699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2659_10699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2659_10699",
    x1: 11.5036,
    y1: 15.8628,
    x2: 28.3474,
    y2: 24.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3374B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2659_10699",
    x1: 15.7721,
    y1: 25.5774,
    x2: 16.9116,
    y2: 27.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3374B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2659_10699",
    x1: 15.7721,
    y1: 23.0112,
    x2: 16.9116,
    y2: 25.1319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3374B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2659_10699"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/Office.64fe632b8b86ffb41f17f217227ecf1a.svg";
export { ForwardRef as ReactComponent };